module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "review"
  }, [_c('div', {
    staticClass: "view-title"
  }, [_c('translate', [_vm._v("Application")])], 1), _vm._v(" "), _c('el-tabs', {
    staticClass: "teamTab",
    attrs: {
      "type": "card",
      "active-name": _vm.initTabName
    },
    on: {
      "tab-click": _vm.onTabClick
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "name": "sql",
      "label": _vm.attrText.sql
    }
  }, [_c('el-tabs', {
    staticClass: "reviewTab",
    attrs: {
      "active-name": _vm.sqlActiveName
    },
    on: {
      "tab-click": _vm.sqlTabClick
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.attrText.pendingApplication,
      "name": "sqlWaitApprove"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.waitSqlApplication.loading),
      expression: "waitSqlApplication.loading"
    }],
    staticClass: "apply-table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.waitSqlApplication.list,
      "stripe": ""
    },
    on: {
      "row-click": _vm.viewApprovingSqlApply
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.attrText.applyer
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.account) ? _c('img', {
          staticClass: "apply-avatar",
          attrs: {
            "src": _vm._f("resetURL")(scope.row.account.avatar),
            "border": "0"
          }
        }) : _vm._e(), _vm._v(" "), (scope.row.account) ? _c('div', {
          staticClass: "apply-avatar-name"
        }, [_vm._v(_vm._s(scope.row.account.name))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.resource
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "limit-text"
        }, [_vm._v(_vm._s(scope.row.resource ? scope.row.resource.name : '-'))]), _vm._v(" "), (scope.row.project) ? _c('div', {
          staticClass: "limit-text"
        }, [_vm._v(_vm._s(scope.row.project.project_name ? scope.row.project.project_name : '-'))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.targetDatabase
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "limit-text"
        }, [_vm._v(_vm._s(scope.row.database ? scope.row.database : '-'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.general
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "limit-text"
        }, [_vm._v(_vm._s(scope.row.comment))]), _vm._v(" "), _c('div', {
          staticClass: "limit-text"
        }, [_vm._v(_vm._s(scope.row.sql))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.createTime,
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("moment")((scope.row.create_time * 1000), 'YYYY-MM-DD HH:mm:ss')) + "\n\t\t\t\t\t\t\t\t")]
      }
    }])
  })], 1), _vm._v(" "), (_vm.waitSqlApplication.totalPage > 1) ? _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-count": _vm.waitSqlApplication.totalPage,
      "page-size": 10,
      "current-page": _vm.waitSqlApplication.currentPage
    },
    on: {
      "update:currentPage": function($event) {
        _vm.waitSqlApplication.currentPage = $event
      },
      "current-change": _vm.waitSqlApplicationChangePage
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.attrText.myApproved,
      "name": "sqlApproved"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.approvedSqlApplication.loading),
      expression: "approvedSqlApplication.loading"
    }],
    staticClass: "apply-table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.approvedSqlApplication.list,
      "stripe": ""
    },
    on: {
      "row-click": _vm.viewApprovedSql
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.attrText.applyer
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.account) ? _c('img', {
          staticClass: "apply-avatar",
          attrs: {
            "src": _vm._f("resetURL")(scope.row.account.avatar),
            "border": "0"
          }
        }) : _vm._e(), _vm._v(" "), (scope.row.account) ? _c('div', {
          staticClass: "apply-avatar-name"
        }, [_vm._v(_vm._s(scope.row.account.name))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.resource
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "limit-text"
        }, [_vm._v(_vm._s(scope.row.resource ? scope.row.resource.name : '-'))]), _vm._v(" "), (scope.row.project) ? _c('div', {
          staticClass: "limit-text"
        }, [_vm._v(_vm._s(scope.row.project.project_name ? scope.row.project.project_name : '-'))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.targetDatabase
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "limit-text"
        }, [_vm._v(_vm._s(scope.row.database ? scope.row.database : '-'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.general
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "limit-text"
        }, [_vm._v(_vm._s(scope.row.comment))]), _vm._v(" "), _c('div', {
          staticClass: "limit-text"
        }, [_vm._v(_vm._s(scope.row.sql))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.createTime,
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("moment")((scope.row.create_time * 1000), 'YYYY-MM-DD HH:mm:ss')) + "\n\t\t\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.status,
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          class: _vm.applyStatus[scope.row.status]
        }, [_vm._v(_vm._s(_vm.sqlApplyStatusText[scope.row.status]))])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.approvedSqlApplication.totalPage > 1) ? _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-count": _vm.approvedSqlApplication.totalPage,
      "page-size": 10,
      "current-page": _vm.approvedSqlApplication.currentPage
    },
    on: {
      "update:currentPage": function($event) {
        _vm.approvedSqlApplication.currentPage = $event
      },
      "current-change": _vm.approvedSqlApplicationChangePage
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.attrText.myApplication,
      "name": "sqlMyApply"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.mySqlApplication.loading),
      expression: "mySqlApplication.loading"
    }],
    staticClass: "apply-table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.mySqlApplication.list,
      "stripe": ""
    },
    on: {
      "row-click": _vm.viewMySqlApply
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.attrText.resourceName
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "limit-text"
        }, [_vm._v(_vm._s(scope.row.resource ? scope.row.resource.name : '-'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.targetDatabase
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "limit-text"
        }, [_vm._v(_vm._s(scope.row.database ? scope.row.database : '-'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.general
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "limit-text"
        }, [_vm._v(_vm._s(scope.row.comment))]), _vm._v(" "), _c('div', {
          staticClass: "limit-text"
        }, [_vm._v(_vm._s(scope.row.sql))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.createTime
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("moment")((scope.row.create_time * 1000), 'YYYY-MM-DD HH:mm:ss')) + "\n\t\t\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.updateTime,
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("moment")((scope.row.update_time * 1000), 'YYYY-MM-DD HH:mm:ss')) + "\n\t\t\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.status,
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          class: _vm.applyStatus[scope.row.status]
        }, [_vm._v(_vm._s(_vm.sqlApplyStatusText[scope.row.status]))])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.mySqlApplication.totalPage > 1) ? _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-count": _vm.mySqlApplication.totalPage,
      "page-size": 10,
      "current-page": _vm.mySqlApplication.currentPage
    },
    on: {
      "update:currentPage": function($event) {
        _vm.mySqlApplication.currentPage = $event
      },
      "current-change": _vm.onMySqlChangePage
    }
  })], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "safe",
      "label": _vm.attrText.safeMode
    }
  }, [_c('el-tabs', {
    staticClass: "reviewTab",
    attrs: {
      "active-name": _vm.safeActiveName
    },
    on: {
      "tab-click": _vm.safeTabClick
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.attrText.pendingApplication,
      "name": "safeWaitApprove"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.safeApprovingList.loading),
      expression: "safeApprovingList.loading"
    }],
    staticClass: "apply-table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.safeApprovingList.list,
      "stripe": ""
    },
    on: {
      "row-click": _vm.viewApprovingSafe
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.attrText.applyer
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.account) ? _c('img', {
          staticClass: "apply-avatar",
          attrs: {
            "src": _vm._f("resetURL")(scope.row.account.avatar),
            "border": "0"
          }
        }) : _vm._e(), _vm._v(" "), (scope.row.account) ? _c('div', {
          staticClass: "apply-avatar-name"
        }, [_vm._v(_vm._s(scope.row.account.name))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.resourceName
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "limit-text"
        }, [_vm._v(_vm._s(scope.row.resource ? scope.row.resource.name : '-'))]), _vm._v(" "), (scope.row.project) ? _c('div', {
          staticClass: "limit-text"
        }, [_vm._v(_vm._s(scope.row.project.project_name ? scope.row.project.project_name : '-'))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.general
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(scope.row.reason) + "\n\t\t\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.updateTime,
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("moment")((scope.row.create_time * 1000), 'YYYY-MM-DD HH:mm:ss')) + "\n\t\t\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.status,
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          class: _vm.applyStatus[scope.row.app_status]
        }, [_vm._v(_vm._s(_vm.safeApplyStatusText[scope.row.app_status]))])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.safeApprovingList.totalPage > 1) ? _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-count": _vm.safeApprovingList.totalPage,
      "page-size": 10,
      "current-page": _vm.safeApprovingList.currentPage
    },
    on: {
      "update:currentPage": function($event) {
        _vm.safeApprovingList.currentPage = $event
      },
      "current-change": _vm.safeApprovingChangePage
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.attrText.myApproved,
      "name": "safeApproved"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.safeApprovedList.loading),
      expression: "safeApprovedList.loading"
    }],
    staticClass: "apply-table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.safeApprovedList.list,
      "stripe": ""
    },
    on: {
      "row-click": _vm.viewApprovedSafe
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.attrText.applyer
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.account) ? _c('img', {
          staticClass: "apply-avatar",
          attrs: {
            "src": _vm._f("resetURL")(scope.row.account.avatar),
            "border": "0"
          }
        }) : _vm._e(), _vm._v(" "), (scope.row.account) ? _c('div', {
          staticClass: "apply-avatar-name"
        }, [_vm._v(_vm._s(scope.row.account.name))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.resourceName
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "limit-text"
        }, [_vm._v(_vm._s(scope.row.resource ? scope.row.resource.name : '-'))]), _vm._v(" "), (scope.row.project) ? _c('div', {
          staticClass: "limit-text"
        }, [_vm._v(_vm._s(scope.row.project.project_name ? scope.row.project.project_name : '-'))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.general
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(scope.row.reason) + "\n\t\t\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.updateTime,
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("moment")((scope.row.create_time * 1000), 'YYYY-MM-DD HH:mm:ss')) + "\n\t\t\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.status,
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          class: _vm.applyStatus[scope.row.app_status]
        }, [_vm._v(_vm._s(_vm.safeApplyStatusText[scope.row.app_status]))])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.safeApprovedList.totalPage > 1) ? _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-count": _vm.safeApprovedList.totalPage,
      "page-size": 10,
      "current-page": _vm.safeApprovedList.currentPage
    },
    on: {
      "update:currentPage": function($event) {
        _vm.safeApprovedList.currentPage = $event
      },
      "current-change": _vm.safeApprovedChangePage
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.attrText.myApplication,
      "name": "safeMyApply"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.mySafeApplyList.loading),
      expression: "mySafeApplyList.loading"
    }],
    staticClass: "apply-table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.mySafeApplyList.list,
      "stripe": ""
    },
    on: {
      "row-click": _vm.viewMySafeApply
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.attrText.resource,
      "prop": "resource.name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "limit-text"
        }, [_vm._v(_vm._s(scope.row.resource ? scope.row.resource.name : '-'))]), _vm._v(" "), (scope.row.project) ? _c('div', {
          staticClass: "limit-text"
        }, [_vm._v(_vm._s(scope.row.project.project_name ? scope.row.project.project_name : '-'))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.effectiveTime
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("moment")((scope.row.expire_time * 1000), 'YYYY-MM-DD HH:mm:ss')) + "\n\t\t\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.createTime
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("moment")((scope.row.create_time * 1000), 'YYYY-MM-DD HH:mm:ss')) + "\n\t\t\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.updateTime
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("moment")((scope.row.update_time * 1000), 'YYYY-MM-DD HH:mm:ss')) + "\n\t\t\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.status,
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          class: _vm.applyStatus[scope.row.app_status]
        }, [_vm._v(_vm._s(_vm.safeApplyStatusText[scope.row.app_status]))])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.mySafeApplyList.totalPage > 1) ? _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-count": _vm.mySafeApplyList.totalPage,
      "page-size": 10,
      "current-page": _vm.mySafeApplyList.currentPage
    },
    on: {
      "update:currentPage": function($event) {
        _vm.mySafeApplyList.currentPage = $event
      },
      "current-change": _vm.onMySafeChangePage
    }
  })], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c(_vm.currentRightPanel, {
    tag: "component",
    attrs: {
      "items": _vm.rightPanelData
    },
    on: {
      "onClosePanel": _vm.onClosePanel,
      "onShowModal": _vm.onShowModal,
      "viewCallback": _vm.viewCallback
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.attrText.previewSQL,
      "visible": _vm.showModal.previewSQL
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal.previewSQL = $event
      }
    }
  }, [(_vm.showModal.previewSQL) ? _c('CodemirrorEditor', {
    ref: "codemirrorEditor",
    attrs: {
      "value": _vm.previewSQL
    },
    on: {
      "input": _vm.onEditorInput
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showModal.previewSQL = false
      }
    }
  }, [_c('translate', [_vm._v("Confirm")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a373831"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/operations/review.vue
// module id = 569
// module chunks = 4 5 6